import { render, staticRenderFns } from "./shoppe-level.vue?vue&type=template&id=6d81e03a&scoped=true"
import script from "./shoppe-level.vue?vue&type=script&lang=js"
export * from "./shoppe-level.vue?vue&type=script&lang=js"
import style0 from "./shoppe-level.vue?vue&type=style&index=0&id=6d81e03a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d81e03a",
  null
  
)

export default component.exports